import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_DISTRICTS = gql`
  query GetRookieDayDistricts {
    rookiedayDistricts {
      id
      name
      routeName
      state
    }
  }
`;
